import { Loader2Icon } from "lucide-react"

import { cn } from "~/lib/utils"

function Spinner({
	className,
	size = "sm",
	...props
}: React.ComponentProps<"svg"> & {
	size?: "xs" | "sm" | "md" | "lg" | "xl" | "2xl"
}) {
	return (
		<Loader2Icon
			role="status"
			aria-label="Loading"
			className={cn(
				"animate-spin",
				size === "xs" && "size-3",
				size === "sm" && "size-4",
				size === "md" && "size-6",
				size === "lg" && "size-8",
				size === "xl" && "size-10",
				size === "2xl" && "size-12",
				className
			)}
			{...props}
		/>
	)
}

export { Spinner }
